module.exports = __webpack_public_path__ + "img/clock_color.1b67e65c.svg";